// src/views/sys/components/newBigMapModule/editingAmap/module/formConfig.js

/**
 * 表单字段配置说明：
 * name: 显示的标签名
 * id: 对应数据中的 key (统一使用驼峰)
 * type: 控件类型 (input, number, select)
 * options: 当 type 为 select 时必填
 */

export const formConfig = {
  // 管线通用配置
  gis_pipe_line: [
    { name: '起点编码', id: 'startClassNo', type: 'input', required: true },
    { name: '终点编码', id: 'endClassNo', type: 'input', required: true },
    { name: '物探点号', id: 'startGeophysicalPointNumber', type: 'input', required: true },
    { name: '连接点号', id: 'endGeophysicalPointNumber', type: 'input', required: true },
    { name: '特征点', id: 'featurePoint', type: 'input' },
    { name: '附属物', id: 'appendage', type: 'input' },
    { name: '构筑物', id: 'structure', type: 'input' },
    { name: '地面高程(m)', id: 'elevation', type: 'number' },
    { name: '起点埋深(m)', id: 'buriedDepth', type: 'number' },
    { name: '终点埋深(m)', id: 'endBuriedDepth', type: 'number' },
    { name: '管材', id: 'pipeMaterial', type: 'input', required: true },
    { name: '管径', id: 'pipeDiameter', type: 'input' },
    {
      name: '管线属性',
      id: 'pipeAttribute',
      type: 'select',
      options: ['原水', '给水', '消防管线']
    },
    // { name: '长度(m)', id: 'length', type: 'number', required: true },
    { name: '压力等级', id: 'voltageType', type: 'select', options: ['市政压力', '中压', '高压', '低压', '超高压'], required: true },
    { name: '片区名称', id: 'zoneName', type: 'input' },
    { name: '所属路段', id: 'road', type: 'input' },
    { name: '原始文件名', id: 'originalFileName', type: 'input' },
    { name: '探测台组编号', id: 'probeGroupNo', type: 'input' },
    { name: '工程名称', id: 'projectName', type: 'input' },
    { name: '工程类别', id: 'projectType', type: 'input' },
    { name: '工程编号', id: 'projectNo', type: 'input' },
    { name: '施工单位', id: 'constructionUnit', type: 'input' },
    { name: '工程管理人', id: 'projectManager', type: 'input' },
    { name: '工程负责人', id: 'projectLeader', type: 'input' },
    { name: '竣工时间', id: 'completionDate', type: 'input' },
    { name: '备注', id: 'remark', type: 'input' }
  ],
  // 管网点通用配置 (基础模板)
  gis_pipe_network: [
    { name: '分类编号', id: 'class_no', type: 'input', required: true },
    { name: '物探点号', id: 'geophysicalPointNumber', type: 'input', required: true },
    { name: '特征点', id: 'featurePoint', type: 'input' },
    { name: '附属物', id: 'appendage', type: 'input' },
    { name: '构筑物', id: 'structure', type: 'input' },
    { name: '坐标X', id: 'point_x', type: 'number', required: true },
    { name: '坐标Y', id: 'point_y', type: 'number', required: true },
    { name: '地面高程(m)', id: 'elevation', type: 'number' },
    { name: '口径', id: 'caliber', type: 'input' },
    { name: '材质', id: 'textureMaterial', type: 'input' },
    { name: '埋深(m)', id: 'buriedDepth', type: 'number' },
    { name: '敷设方式', id: 'layingMode', type: 'input' },
    { name: '片区名称', id: 'zoneName', type: 'input' },
    { name: '所属道路', id: 'road', type: 'input' },
    { name: '原始文件名', id: 'originalFileName', type: 'input' },
    { name: '探测台组编号', id: 'probeGroupNo', type: 'input' },
    { name: '水表数量', id: 'water_count', type: 'number' },
    { name: '阀门类型', id: 'valve_type', type: 'input' },
    { name: '状态', id: 'status', type: 'select', options: ['良好', '密封性能差', '损坏', '联通阀门关闭'] },
    { name: '品牌', id: 'brand', type: 'input' },
    { name: '出厂编号', id: 'factoryNumber', type: 'input' },
    { name: '型号', id: 'model', type: 'input' },
    { name: '工程名称', id: 'projectName', type: 'input' },
    { name: '工程类别', id: 'projectType', type: 'input' },
    { name: '工程编号', id: 'projectNo', type: 'input' },
    { name: '施工单位', id: 'constructionUnit', type: 'input' },
    { name: '工程管理人', id: 'projectManager', type: 'input' },
    { name: '工程负责人', id: 'projectLeader', type: 'input' },
    { name: '竣工时间', id: 'completion_date', type: 'input' },
    { name: '备注', id: 'remark', type: 'input' },
    { name: '加压泵类型', id: 'forcingPumpStatus', type: 'input' },
    { name: '机组数量', id: 'unitNum', type: 'number' },
    { name: '机组功率', id: 'unitPower', type: 'number' },
    { name: '阀门级别', id: 'valveLevel', type: 'number' },
    { name: '阀门编号', id: 'valveNo', type: 'input' }
  ]
};

// 增加特定类型的快捷映射
formConfig.gis_pipe_network_valve = [...formConfig.gis_pipe_network];
formConfig.gis_pipe_network_water_meter = [...formConfig.gis_pipe_network];

export default formConfig;
